module.exports = __webpack_public_path__ + "media/images/universe_landing_pages/hero_banner/component/beauty-mobile-33b0a45f70a905c084f9ced27ca6ceb2.jpg";